import { useEffect } from 'react'

const ScrollToTop = () => {
  const pathName = window.location.pathname

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [pathName])

  return null
}

export default ScrollToTop
